import { computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import store from '@/store/store'
import { ModuleNamespaces, ContextName } from '@/store/types/storeGlobalTypes'
import { AlertsTypes, AlertsData } from '@/store/modules/alerts/alertsTypes'

export default function useContactBankAccount() {
  const { t } = useI18n()

  const contactId = computed(() =>
    String(store.getters[`${ModuleNamespaces.SELECTED_REGISTER}/getSelectedRegisterId`](ContextName.CONTACT) ?? '0')
  )

  const hasExistingAccounts = computed<boolean>(
    () => store.getters[`${ModuleNamespaces.CONTACTS}/hasContactAccounts`]
  )

  const alertData: AlertsData = {
    type: AlertsTypes.INFO,
    title: t('components.alerts.bank_account_one_per_type_title') as string,
    message: t('components.alerts.bank_account_one_per_type_message') as string
  }

  const refreshContactAccounts = async () => {
    await store.dispatch(`${ModuleNamespaces.CONTACTS}/fetchContactAccounts`, contactId.value)
  }

  return { contactId, hasExistingAccounts, alertData, refreshContactAccounts }
}
